// 部署环境配置项

const globalPath = {
  jsonPath: './',
  serverUrl: 'https://www.rongchuangxinghui.com:18080/gateway', // 线上地址
  imgPathWater: 'https://www.rongchuangxinghui.com:18080/fileupload', // 图片资源前缀
};

module.exports = globalPath;
